import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

export const Introduction = () => {
  return (
    <>
      <section id="#about">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different">Me</span>
          </h2>
          <div className="introduction">
            <div className="introduction_logocontainer">
              <img
                src="MyImage.jpg"
                alt="Images"
              />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                Hi everyone! I'm based in&nbsp; 
                <span className="different">Mumbai, India</span>.
                I hold a Bachelor’s degree in Banking and Insurance and developed a passion for technology through a boot camp at Masai School. With over 3 years of experience as a Software Engineer, I focus on building innovative solutions and staying updated with the ever-changing tech industry.
              </h4>
              <h4>
                Outside of coding, I enjoy engaging in a variety of activities:
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Playing Games{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Solving Complex Problems{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Exploring Algorithms and Data Structures{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Watching Movies and Anime Series{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Listening to Music{" "}
              </h4>
              <h4>
                These activities help me stay balanced and continuously grow both personally and professionally.
              </h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
